<!-- begin:: Footer -->
<div class="footer bg-white py-4 d-flex flex-lg-column " id="kt_footer" [ngClass]="footerClasses">
	<div [ngClass]="footerContainerClasses" class=" d-flex flex-column flex-md-row align-items-center justify-content-between">
		<!--begin::Copyright-->
		<div class="text-dark d-flex align-items-center">
			<p class="text-dark-75 m-0">
				Asegúrate Limitada - {{version}}
			</p>
		</div>
		<!--end::Copyright-->
		<div class="h-100">
			<a href="https://twitter.com/AsegurateColombia" target="_blank">
			  <img src="../../../../assets/media/logos/twitter.png" alt="twitter">
			</a>
			<a href="https://www.facebook.com/Aseguratecolombia/" target="_blank">
			  <img src="../../../../assets/media/logos/facebook.png" alt="facebook" style="margin-left: 7px;">
			</a>
			<a href="https://linkedin.com/company/Asegurate-s-a-s/" target="_blank">
			  <img src="../../../../assets/media/logos/linkedin.png" alt="linkedin" style="margin-left: 7px;">
			</a>
		  </div>
    	<!--begin::Nav-->
    	<div class="nav nav-dark">
			<a href="http://www.aseguratelimitada.com/" target="_blank" class="nav-link pl-3 pr-0">
				www.aseguratelimitada.com
			</a>
		</div>
		<!--end::Nav-->
	</div>
</div>
<!-- end:: Footer -->
